import { ReactComponent as GoogleLogo } from "assets/svg/google-logo.svg";
import { Button } from "../ui/button";

export const AuthenticateWithGoogleButton = ({
  onClick,
  disabled = false,
  buttonText,
}) => (
  <Button variant="outline" onClick={onClick} disabled={disabled}>
    <GoogleLogo />
    {buttonText}
  </Button>
);
